import { render, staticRenderFns } from "./DataGk.vue?vue&type=template&id=11859339&scoped=true&"
import script from "./DataGk.vue?vue&type=script&lang=js&"
export * from "./DataGk.vue?vue&type=script&lang=js&"
import style0 from "./DataGk.vue?vue&type=style&index=0&lang=less&"
import style1 from "./DataGk.vue?vue&type=style&index=1&id=11859339&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11859339",
  null
  
)

export default component.exports